import { render, staticRenderFns } from "./OriginSystem.vue?vue&type=template&id=697fe0a6"
import script from "./OriginSystem.vue?vue&type=script&lang=js"
export * from "./OriginSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports